import { SpyneTrait } from 'spyne';
import { gsap } from 'gsap';
import { Draggable } from 'gsap/Draggable';
import { InertiaPlugin } from 'gsap/InertiaPlugin';

gsap.registerPlugin(Draggable, InertiaPlugin);

export class PageHomeStructuralApiTraits extends SpyneTrait {

  constructor(context) {
    const traitPrefix = 'structuralAPI$';
    super(context, traitPrefix);
  }

  static structuralAPI$OnImgPress(e) {
    const bodyEl = this.props.el$('.structural-api__codemap-body').el;
    const imgEl = this.props.el$('.structural-api__codemap-image').el;

    if (!bodyEl || !imgEl) {
      return;
    }

    // Only initialize once
    if (this._codemapDraggable) {
      retiurn;
    }

    const [draggable] = Draggable.create(imgEl, {
      type: 'x,y',
      bounds: {
        minX: -(imgEl.offsetWidth - bodyEl.offsetWidth),
        minY: -(imgEl.offsetHeight - bodyEl.offsetHeight),
        maxX: 0,
        maxY: 0
      },
      inertia: true,
      edgeResistance: 0.85,
      onPress() {
        bodyEl.classList.add('is-dragging');
      },
      onRelease() {
        bodyEl.classList.remove('is-dragging');
      }
    });

    this._codemapDraggable = draggable;
  }

}
